import { JobAddressSelection } from "../../Jobbing/models/JobAddressSelection";
import { DangerousGoodsCode } from "../../products/models/DangerousGoodsCode";
import { ContainerManualBilling } from "./ContainerManualBilling";
import { CreateContainerJobRequestPortData } from "./CreateContainerJobRequestPortData";
import { CreateContainerJobSurcharge } from "./CreateContainerJobSurcharge";

export class CreateContainerJobRequestItem{
  public containerNumber: string = '';
  public fullRequestedDeliveryDate: Date | null = null;
  public mtRequestedDeliveryDate: Date | null = null;
  public intermodalFullRequestedDeliveryDate: Date | null = null;
  public intermodalMtRequestedDeliveryDate: Date | null = null;
  public orderNumber: string = "";
  public customerReference: string = "";
  public csrComments: string = "";
  public billingNotes: string = "";
  public driverNotes: string = "";
  public weightKg: number = 0;
  public containerSizeCode: string = '';
  public containerTypeCode: string = '';
  public temperature: number = 0;
  public isHighGauge: boolean = false;
  public isWideGauge: boolean = false;
  public plannedLoadDate: Date | null = null;
  public plannedDevanDateUtc: Date | null = null;
  public plannedDevanType: any | null = null;
  public plannedPackDateUtc: Date | null = null;
  public plannedPackType: any | null = null;
  public doorDirectionCode: string = '';
  public fullLegOnly: boolean | null = false;
  public storageDays: number = 0;
  public emptyContainerDepotContainerPortId: number | null = null;
  public emptyContainerDepotCode: string | null = null;
  public emptyContainerAccessCode: string | null = null;
  public emptyContainerIntermodalDepotContainerPortId: number | null = null;
  public emptyContainerIntermodalDepotCode: string | null = null;
  public emptyContainerIntermodalAccessCode: string | null = null;
  public pin: string | null = null;
  public expressPin: string | null = null;
  public unloadTypeCode: string = '';
  public inboundHubId?: number = 0;
  public outboundHubId?: number = 0;
  public inboundIntermodalHubId?: number = 0;
  public outboundIntermodalHubId?: number = 0;
  public sealNumber: string = '';
  public mpiInspectionRequired: boolean = false;
  public needsLift: boolean = false;
  public useManualRating: boolean = false;
  public manualRating: ContainerManualBilling | null = null;
  public dangerousGoodClasses: DangerousGoodsCode[] = [];
  public fromAddress: JobAddressSelection | null = null;
  public toAddress: JobAddressSelection | null = null;
  public portData: CreateContainerJobRequestPortData | null = null;
  public intermodalPortData: CreateContainerJobRequestPortData | null = null;
  public surcharges: CreateContainerJobSurcharge[] = [];
  public requiresXray: boolean = false;
  public requiresWeigh: boolean = false;
  public fullLegGridNumber: string = '';
  public mtLegGridNumber: string = '';
}
